import ServiceBase from "@app/shared/serviceBase";
import { TableType, ViewableField } from "@app/viewable-fields/viewableFields";

/** Handles communication across the wire when retrieving and interacting with projects. */
class ViewableFieldsService extends ServiceBase {
  /**
   * Returns the viewable fields associated with a particular resource, resource type and table type.
   * @param resourceId
   * @param resourceType
   * @param tableType
   * @param projectRunConfigurationId
   * @param specialtyGroupCode
   */
  public async getViewableFieldsByCustomProject(customProjectId: number, runConfigurationId: number, specialtyGroupCode: string, tableType: TableType): Promise<ViewableField[]> {
    return await this.makeGet<ViewableField[]>(`viewablefields/customProject/${customProjectId}/runconfiguration/${runConfigurationId}/tableType/${tableType}?specialtyGroupCode=${specialtyGroupCode}`);
  }

  /**
   * Upserts the provided set of viewable fields into persistent storage.
   * Depending upon the provided data can be done at a global or individual resource level.
   * @param resourceId
   * @param resourceType
   * @param specialtyGroupCode
   * @param tableType
   */
  public async saveViewableFields(customProjectId: number, runConfigurationId: number, specialtyGroupCode: string, tableType: TableType, fields: ViewableField[]): Promise<void> {
    return await this.makePut<void>(`viewablefields/customProject/${customProjectId}/runconfiguration/${runConfigurationId}/tableType/${tableType}/save?specialtyGroupCode=${specialtyGroupCode}`, fields);
  }

  /**
   * Deletes/Resets the field information for all globally defined field settings.
   * @param resourceId
   * @param resourceType
   * @param tableType
   * @param specialtyGroupCode
   */
  public async resetViewableFields(customProjectId: number, runConfigurationId: number, specialtyGroupCode: string, tableType: TableType): Promise<void> {
    return await this.makePut<void>(`viewablefields/customProject/${customProjectId}/runconfiguration/${runConfigurationId}/tableType/${tableType}/reset?specialtyGroupCode=${specialtyGroupCode}`);
  }
}

export { ViewableFieldsService };
